import { observable } from "mobx";
import { ActionStore } from "higher-order/ActionStore";
import isEmpty from "lodash/isEmpty";
import ApiGetter from "shared/models/ApiGetter";
import format from "string-format";

export default class ContentStore extends ActionStore {
    @observable content;

    constructor(props, dispatcher) {
        super(dispatcher);
        this.apiGetter = new ApiGetter(dispatcher);
        this.content = observable.map(props.content);
        this.extractContent = this.createExtractContentFunction(this.content);
    }

    createExtractContentFunction(content) {
        return function(contentKey, sharedKey, stringFormatArgs) {
            let outputContent;
            if (!isEmpty(sharedKey)) {
                outputContent = content.has(sharedKey) ? content.get(sharedKey)[contentKey] : "";
            } else {
                outputContent = content.get(contentKey);
            }
            const isContentEmpty = isEmpty(outputContent);
            if (!isContentEmpty && stringFormatArgs) {
                outputContent = format(outputContent, stringFormatArgs);
            }
            return outputContent;
        };
    }
}
